import React from "react";

import { ReactComponent as PdfIcon } from "src/images/pdf-attachment.svg";
import { ReactComponent as XlsIcon } from "src/images/xls-attachment.svg";
import { ReactComponent as DocIcon } from "src/images/doc-attachment.svg";
import { ReactComponent as PptxIcon } from "src/images/pptx-attachment.svg";
import { ReactComponent as ZipIcon } from "src/images/zip-attachment.svg";
import { ReactComponent as TxtIcon } from "src/images/txt-attachment.svg";
import { ReactComponent as MusicIcon } from "src/images/music-attachment.svg";
import { ReactComponent as VideoIcon } from "src/images/video-attachment.svg";
import { ReactComponent as FileGreyIcon } from "src/images/files/file-grey.svg";

const attachmentClassName = "attachment-file__icon";

export default function getAttachmentIcon(fileExtension: string | undefined) {
  switch (fileExtension) {
    case "pdf":
      return <PdfIcon className={attachmentClassName} />;
    case "xls":
    case "xlsx":
    case "csv":
      return <XlsIcon className={attachmentClassName} />;
    case "doc":
    case "odc":
      return <DocIcon className={attachmentClassName} />;
    case "docx":
      return <DocIcon className={attachmentClassName} />;
    case "ppt":
    case "pptx":
    case "ods":
      return <PptxIcon className={attachmentClassName} />;
    case "zip":
      return <ZipIcon className={attachmentClassName} />;
    case "txt":
      return <TxtIcon className={attachmentClassName} />;
    case "mp3":
      return <MusicIcon className={attachmentClassName} />;
    case "mp4":
    case "mov":
    case "avi":
      return <VideoIcon className={attachmentClassName} />;
    default:
      return <FileGreyIcon className={attachmentClassName} />;
  }
}
